import {formatNumberToBRLCurrency} from 'presentation/utils/formatNumberToBRLCurrency';
import {convertBRLCurrencyToNumber} from 'presentation/utils/convertBRLCurrencyToNumber';
import {sumObjectArrayNumbers} from 'presentation/utils/sumObjectArrayNumbers';
import type {TherapyDataSchema} from '../../schemas/therapyDataSchema';

const calculateAndFormatTotalSessionsValue = (sessions: TherapyDataSchema['sessions']) => {
	const totalValue = sumObjectArrayNumbers(sessions, 'sessionValue', convertBRLCurrencyToNumber);
	return formatNumberToBRLCurrency(totalValue);
};

export {calculateAndFormatTotalSessionsValue};
